import { GetRepresentativesListingSchema } from '../schemas/RepresentativeZodSchema';
import { Representative } from '../types/Representative';

export function transformRepresentativeResponse(data?: unknown): Representative[] {
    const parsedResult = GetRepresentativesListingSchema.safeParse(data);

    if (!parsedResult.success) {
        console.error(
            'Validation failed for getRepresentativesListing:',
            parsedResult.error.errors
        );
        return [];
    }

    const parsedRepresentatives = parsedResult.data.getObjectFolder.children;

    return parsedRepresentatives.map((r) => ({
        id: r.id,
        key: r.key,
        name: r.name,
        phone: r.phone ?? null,
        email: r.email ?? null,
        salesAddressLine1: r.salesAddressLine1 ?? null,
        salesAddressLine2: r.salesAddressLine2 ?? null,
        salesAddressLine3: r.salesAddressLine3 ?? null,
        countryOrSubnational: r.countryOrSubnational.map((c: { id: string }) => c.id) ?? [],
        logo: r.logo ?? null,
        freeFormText: r.text ?? null, // Ensure freeFormText is set to null if undefined
    }));
}
